import { render } from "./PSPDFKitContainer.vue?vue&type=template&id=5d5b70f1"
import script from "./PSPDFKitContainer.vue?vue&type=script&lang=js"
export * from "./PSPDFKitContainer.vue?vue&type=script&lang=js"

import "./PSPDFKitContainer.vue?vue&type=style&index=0&id=5d5b70f1&lang=scss"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__